import { useState, useEffect } from 'react'
import {
  Context,
  enableDebugConsoleLogDrain,
  enableContextDevTools,
  CookieTransitionDataStore
} from '@uniformdev/context'
import { getBrand } from '../../utils/ConfigProvider'
import { UpdateEnrichment } from '../../helpers/UpdateEnrichment'
import { hasMarketingConsent } from '../../helpers/hasMarketingConsent'

const fetchUniformManifest = async () => {
  try {
    const url = 'https://cdn.argos.co.uk/assets/personalisation/manifest.json'
    const data = await fetch(url)
    const json = await data.json()
    return json
  } catch (err) {
    console.error('Error fetching manifest', err)
  }
  return null
}

const setUniformContext = async setContext => {
  const plugins = [enableContextDevTools()]

  if (process.env.NODE_ENV !== 'production') {
    plugins.push(enableDebugConsoleLogDrain('debug'))
  }
  const manifest = await fetchUniformManifest()

  const context = new Context({
    defaultConsent: false,
    transitionStore: new CookieTransitionDataStore({}),
    manifest,
    plugins
  })
  setContext(context)
}

export const UniformTracking = ({ topLevelCategoryId, categoryId, categoryLevel }) => {
  const [context, setContext] = useState()

  useEffect(() => {
    if (getBrand() === 'argos') {
      setUniformContext(setContext)
    }
  }, [])

  useEffect(() => {
    const hasConsent = hasMarketingConsent()
    context?.storage.updateData([
      {
        type: 'consent',
        data: hasConsent
      }
    ])
  }, [context])

  useEffect(() => {
    if (topLevelCategoryId && context) {
      UpdateEnrichment(1, topLevelCategoryId, context)
      if (categoryLevel > 1) {
        UpdateEnrichment(categoryLevel, categoryId, context)
      }
    }
  }, [topLevelCategoryId, context])

  return null
}
